import axios from 'axios'
import React, { createContext, useContext, useEffect, useState } from 'react'
import { API_URL } from '../config/api'

interface Agent {
  id: number | string
  agent_name: string
  status?: string
  expertise?: string
  user_type?: string
  agent_type?: string
  owner_id?: number
}

interface AgentContextType {
  agents: Agent[]
  activeAgent: Agent | null
  setActiveAgent: (agent: Agent | null) => void
  loading: boolean
  error: string | null
}

const AgentContext = createContext<AgentContextType | undefined>(undefined)

export function AgentProvider({ children }: { children: React.ReactNode }) {
  const [agents, setAgents] = useState<Agent[]>([])
  const [activeAgent, setActiveAgent] = useState<Agent | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const loadAgents = async () => {
      try {
        setLoading(true)
        const token = localStorage.getItem('token')
        const res = await axios.get(`${API_URL}/api/agents/my`, {
          headers: { Authorization: `Bearer ${token ?? ''}` }
        })

        let agentList: Agent[] = []
        const v = res.data
        if (Array.isArray(v)) agentList = v
        else if (Array.isArray(v?.agents)) agentList = v.agents
        else if (Array.isArray(v?.agents?.results)) agentList = v.agents.results
        else if (Array.isArray(v?.results)) agentList = v.results

        setAgents(agentList)

        // Default: kullanıcının kendi agent'ı (user_agent tipi), yoksa ilk agent
        const myAgent = agentList.find(a => a.user_type === 'user_agent' || a.agent_type === 'user_agent')
        setActiveAgent(myAgent ?? agentList[0] ?? null)
      } catch (err) {
        console.error('Failed to load agents:', err)
        setError(err instanceof Error ? err.message : 'Failed to load agents')
      } finally {
        setLoading(false)
      }
    }
    loadAgents()
  }, [])

  return (
    <AgentContext.Provider value={{ agents, activeAgent, setActiveAgent, loading, error }}>
      {children}
    </AgentContext.Provider>
  )
}

export function useAgents() {
  const context = useContext(AgentContext)
  if (!context) throw new Error('useAgents must be used within AgentProvider')
  return context
}
